import { ToolResult } from '../../types/tool.types';
import { ToolContext } from '../tool-context.type';

export async function setGeoLocation(args: any, context: ToolContext): Promise<ToolResult> {
	const { threeInstance, publish } = context;

	const { latitude, longitude, enabled = true } = args;

	// Validate latitude
	if (latitude === undefined || typeof latitude !== 'number') {
		return {
			success: false,
			error: 'latitude parameter is required and must be a number (-90 to 90)'
		};
	}
	if (latitude < -90 || latitude > 90) {
		return {
			success: false,
			error: 'latitude must be between -90 and 90 degrees'
		};
	}

	// Validate longitude
	if (longitude === undefined || typeof longitude !== 'number') {
		return {
			success: false,
			error: 'longitude parameter is required and must be a number (-180 to 180)'
		};
	}
	if (longitude < -180 || longitude > 180) {
		return {
			success: false,
			error: 'longitude must be between -180 and 180 degrees'
		};
	}

	// Apply geographic lighting
	if (!threeInstance) {
		return { success: false, error: 'Three.js instance not available' };
	}

	const location = { latitude, longitude };

	if (enabled) {
		if (threeInstance.enableGeoLighting) {
			threeInstance.enableGeoLighting(location);
		} else {
			return { success: false, error: 'Geographic lighting not available in this version' };
		}
	} else {
		if (threeInstance.disableGeoLighting) {
			threeInstance.disableGeoLighting();
		}
	}

	publish('geo_lighting', 'location_changed', {
		ref: 'geo_location',
		old: null,
		new: { latitude, longitude, enabled }
	});

	return {
		success: true,
		data: { latitude, longitude, enabled }
	};
}

